import {
  ref,
  onMounted,
  onUnmounted,
  nextTick,
} from 'vue';
import {
  dispatchPageStoreChange,
  pageStoreChangeListener,
  removeStoreChangeListener,
  STORE_CHANGED_ON_HEADER,
} from '@common-vue/locator/src/utils/globalStoreChange';
import useFacets from './useFacets';

export default function useLocatorAndZipSlideouts({ onBopsUpdate, onSddUpdate, onGlobalStoreChange }) {
  const { toggleLocatorDrawer, toggleZipDrawer } = useFacets();

  const locatorSlideoutShown = ref(false);
  const zipcodeSlideoutShown = ref(false);

  const closeSlideout = () => {
    toggleLocatorDrawer();
    locatorSlideoutShown.value = false;
  };

  const toggleLocatorSlideout = async () => {
    locatorSlideoutShown.value = true;
    await nextTick();
    toggleLocatorDrawer();
  };

  const toggleZipSlideout = async () => {
    zipcodeSlideoutShown.value = true;
    await nextTick();
    toggleZipDrawer();
  };

  const handleZipCodeUpdate = (zip) => {
    dispatchPageStoreChange();
    onSddUpdate(zip);
  };

  const handleStoreSelected = (store) => {
    const { locationNumber } = store;

    closeSlideout();
    dispatchPageStoreChange();
    onBopsUpdate(locationNumber, store.localStorageModel?.address?.zipCode);
  };

  const handleStoresFound = (...args) => {
    console.log('handleStoresFound', args); // eslint-disable-line no-console
  };

  const handleLocationError = (val) => {
    /* istanbul ignore else */
    if (val.status === 404) {
      // TODO show an error message?
    }
  };

  const handleHeaderStoreChange = () => {
    onGlobalStoreChange();
  };

  const onSddChangeClick = () => toggleZipSlideout();
  const onBopsChangeClick = () => toggleLocatorSlideout();
  const onHeaderStoreChange = () => handleHeaderStoreChange();

  const initWindowDnfEvents = () => {
    window.removeEventListener('filtering-facets-change-sdd', onSddChangeClick);
    window.addEventListener('filtering-facets-change-sdd', onSddChangeClick);

    window.removeEventListener('filtering-facets-change-bops', onBopsChangeClick);
    window.addEventListener('filtering-facets-change-bops', onBopsChangeClick);

    removeStoreChangeListener(STORE_CHANGED_ON_HEADER, onHeaderStoreChange);
    pageStoreChangeListener(onHeaderStoreChange);
  };

  const removeWindowDnfEvents = () => {
    window.removeEventListener('filtering-facets-change-sdd', onSddChangeClick);
    window.removeEventListener('filtering-facets-change-bops', onBopsChangeClick);
  };

  onMounted(initWindowDnfEvents);
  onUnmounted(removeWindowDnfEvents);

  return {
    locatorSlideoutShown,
    zipcodeSlideoutShown,
    handleStoreSelected,
    handleStoresFound,
    handleLocationError,
    handleZipCodeUpdate,
  };
}
